import { useId, useLayoutEffect, useRef, type ReactNode } from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';

export function EbookEditorSettingsDialog({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useLayoutEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    element?.showModal();
    return () => {
      element?.close();
      if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
    };
  }, []);
  return (
    <dialog
      ref={dialog}
      className="ebook-editor-settings-dialog"
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <header>
        <h2 id={titleId}>答案工具</h2>
        <button type="button" aria-label="关闭答案工具" onClick={onClose}>
          <Cross2Icon />
        </button>
      </header>
      <div className="ebook-editor-settings-content">{children}</div>
      <footer>
        <button type="button" onClick={onClose}>
          完成
        </button>
      </footer>
    </dialog>
  );
}
